import React from 'react';
import Pagination from '../Pagination/Pagination';
import ReviewCard from './ReviewCard';

interface Review {
  author: string;
  content: string;
  rating: string;
  finalRating: string;
  date: string;
  location: string;
}

interface ReviewListProps {
  reviews: Review[];
  currentPage: number;
  onPageChange: (page: number) => void;
  sortFilter: string;
  name: string;
}

const ReviewList: React.FC<ReviewListProps> = ({
  name,
  reviews,
  currentPage,
  onPageChange,
  sortFilter,
}) => {
  const itemsPerPage = 8;

  // Check if reviews array is empty or null
  if (!reviews || reviews.length === 0 || reviews === null) {
    return <div>No reviews available</div>;
  }

  const sortedReviews = [...reviews];
  switch (sortFilter) {
    case 'recent':
      sortedReviews.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      break;
    case 'oldest':
      sortedReviews.sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      break;
    case 'highest':
      sortedReviews.sort((a, b) => parseInt(b.rating) - parseInt(a.rating)); // Sort by highest rating
      break;
    default:
      break;
  }

  const totalPages = Math.ceil(sortedReviews.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentReviews = sortedReviews.slice(startIndex, endIndex);

  return (
    <div>
      <div className="space-y-6">
        {currentReviews.map((review, index) => (
          <ReviewCard
            key={index}
            name={review.author}
            content={review.content}
            rating={review.rating || review.finalRating || '0'}
            date={review.date}
            location={review.location || 'USA'}
            company={name}
          />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default ReviewList;
